import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import permissions from 'app/models/Permissions';
import { CustomerService } from '../../../services/customer.service';
import { SessionStorageService } from '../../../services/session-storage.service';
import { forkJoin } from 'rxjs';
import Utils from '../../../shared/utils';

@Component({
	selector: 'app-components-managecustomer-customersynopsis',
	templateUrl: './CustomerSynopsis.component.html'
})
export class CustomerSynopsisComponent implements OnInit {
    @Input() customer: Boo.Objects.Customer;
    @Input() customerSynopsis: string;
    @Output() refreshCustomer = new EventEmitter<void>();

    canUpdateSynopsis = false;

    constructor(private customerService: CustomerService, private sessionService: SessionStorageService) { }

    ngOnInit(): void {
        forkJoin({
            user: this.sessionService.getUser(),
            partner: this.sessionService.getPartner()
        }).subscribe(({ user, partner }) => {
            this.canUpdateSynopsis = Utils.hasPermission(partner, user.PartnerUsers, permissions.CanUpdateSynopsis, user);
        });
    }

    save() {
        this.customerSynopsis = $.trim(this.customerSynopsis);
        this.customer.Synopsis = this.customerSynopsis;

        this.customerService.save(this.customer)
            .subscribe(() => {
                toastr.success('Sucessfully updated Synopsis.');
                this.refreshCustomer.emit();
            });
    }
}
